// extracted by mini-css-extract-plugin
export default {"imageRender":"patternDevGraph_imageRender__8uTgN"};